export const PROCESS_LINEAGE_REQ = 'PROCESS_LINEAGE_REQ'
export const PROCESS_LINEAGE_SUCCESS = 'PROCESS_LINEAGE_SUCCESS'
export const PROCESS_LINEAGE_ERROR = 'PROCESS_LINEAGE_ERROR'



// WEBPACK FOOTER //
// ./src/store/modules/process_lineage/process-lineage.type.js